var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"table"},[_vm._m(0),_c('tbody',_vm._l((_vm.showData),function(pkb){return _c('tr',[_c('td',[_vm._v(_vm._s(pkb.code))]),_c('td',[_vm._v(_vm._s(pkb.pkb))]),_c('td',[_vm._v(_vm._s(_vm.numberWithCommas(pkb.count)))])])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Type Code")]),_c('th',[_vm._v("Operation")]),_c('th',[_vm._v("Quantity")])])])
}]

export { render, staticRenderFns }